export const getColorVariant = (index) => {
  if (index % 2 === 0 && index % 4 !== 0) {
    return "purple";
  } else if (index % 4 === 0) {
    return "red";
  } else if (
    (index % 3 === 0 && index % 6 !== 0 && index % 9 !== 0) ||
    index % 7 === 0
  ) {
    return "blue";
  }
};
